import Dispatcher from './Dispatcher';
import ActionTypes from './ActionTypes';
import checkStatus from '../utils/checkStatus';
import api from '../utils/api';
import dispatchHttpError from '../utils/dispatchHttpError';
import JwtStore from "./JwtStore";

export default {
  all(collectionId, themeId) {
    return fetch(api(`collections/${collectionId}/themes`), {
      headers: {
        'Authorization': `Bearer ${JwtStore.getToken()}`,
        'Accept': 'application/json'
      },
    })
      .then(checkStatus)
      .then(response => response.json())
      .then(response => Dispatcher.dispatch({
        actionType: ActionTypes.THEME_STORE_ALL_COMPLETE,
        themes: response.data.themes,
      }))
      .catch(dispatchHttpError);
  },

  find(collectionId, themeId) {
    return fetch(api(`collections/${collectionId}/themes/${themeId}`), {
      headers: {
        'Authorization': `Bearer ${JwtStore.getToken()}`,
        'Accept': 'application/json'
      },
    })
      .then(checkStatus)
      .then(response => response.json())
      .then(response => Dispatcher.dispatch({
        actionType: ActionTypes.THEME_STORE_FIND_COMPLETE,
        theme: response.data,
      }))
      .catch(dispatchHttpError);
  },
}
